import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { PaymentRoutes } from "./Contracts/Routes";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://1634f31e041a99c1e09709f4e6a21c25@o255532.ingest.us.sentry.io/4509309482893312",
  environment: import.meta.env.VITE_NODE_ENV,
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN ?? ""}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID ?? ""}
      authorizationParams={{
        redirect_uri: `${window.location.origin}${PaymentRoutes.GETTING_STARTED}`,
        scope: "openid profile",
        audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? ""
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
